import React from "react";
import { useTranslation } from "react-i18next";
import { useFormatPrice } from "@/hooks/useFormatPrice";

type PriceProps = {
  amount: number | null | undefined;
  className?: string;
  style?: React.CSSProperties;
};

const RiyalIcon = () => (
  <svg width="1.2em" height="1.33em" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ transform: "translateY(0.15em)" }}>
    <g clipPath="url(#clip0_1432_13324)">
      <path d="M11.2025 17.7177C10.8813 18.4258 10.669 19.1942 10.5876 20L17.385 18.5635C17.7062 17.8556 17.9184 17.0871 17.9999 16.2812L11.2025 17.7177Z" fill="currentColor"/>
      <path d="M17.3849 14.2599C17.7061 13.552 17.9184 12.7835 17.9998 11.9776L12.7048 13.0972V10.945L17.3847 9.9563C17.7059 9.2484 17.9183 8.47985 17.9996 7.67405L12.7047 8.79265V1.0527C11.8933 1.50558 11.1728 2.10842 10.587 2.81951V9.24028L8.46943 9.68776V0C7.65809 0.452726 6.93754 1.05572 6.35181 1.76681V10.1351L1.61363 11.136C1.29242 11.8439 1.07994 12.6125 0.998439 13.4183L6.35181 12.2873V14.9976L0.614626 16.2096C0.29342 16.9175 0.081098 17.6861 -0.000244141 18.4919L6.00499 17.2232C6.49384 17.1221 6.914 16.8347 7.18717 16.4393L8.28849 14.8161V14.8158C8.40282 14.6478 8.46943 14.4454 8.46943 14.2273V11.8398L10.587 11.3923V15.6967L17.3847 14.2596L17.3849 14.2599Z" fill="currentColor"/>
    </g>
    <defs>
      <clipPath id="clip0_1432_13324">
        <rect width="18" height="20" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

export function Price({ amount, className, style }: PriceProps) {
  const { format, currency } = useFormatPrice();
  const { i18n } = useTranslation();

  if (currency === "SAR" || currency === "ر.س.") {
    const formattedAmount = new Intl.NumberFormat(i18n.language || "en", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(typeof amount === "number" ? amount : 0);

    const isRtl = i18n.dir() === "rtl";

    return (
      <span
        className={className}
        style={{
          display: "inline-flex",
          alignItems: "baseline",
          gap: 4,
          ...style,
        }}
      >
        {isRtl ? (
          <>
            <span>{formattedAmount}</span>
            <RiyalIcon />
          </>
        ) : (
          <>
            <RiyalIcon />
            <span>{formattedAmount}</span>
          </>
        )}
      </span>
    );
  }

  return (
    <span className={className} style={style}>
      {format(amount)}
    </span>
  );
}
